// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"458":"d87844a2","787":"bf210ddd","858":"d9224472","919":"3a65482b"}[chunkId] + ".chunk.js";
};